import PropTypes from "prop-types";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { addEditRelation } from "../../Redux/Slices/relationSlice";


const AddEditRelation = ({ isOpen, onClose, rowData }) => {
  
  const initialValues = {
    relationId: "",
    english_name: "",
    gujarati_name: "",
  };

  const dispatch = useDispatch();
    
  const [formikInitialValue, setFormikInitialValue] = useState(initialValues);

  const validationSchema = Yup.object().shape({
    // english_name: Yup.string().required("Relation name in English is required"),
    // gujarati_name: Yup.string().required("Relation name in Gujarati is required"),
  });
  
   useEffect(() => {
        if (rowData) {
            setFormikInitialValue({
                relationId: rowData?._id || '',
                english_name: rowData?.english_name || "",
                gujarati_name: rowData?.gujarati_name || "",
            });
        } else {
            setFormikInitialValue(initialValues);
        }
    }, [rowData]);

    const handleSubmit = async (values) => {
        const payload = {
            relationId: values?.relationId || "",
            english_name: values?.english_name || "",
            gujarati_name: values?.gujarati_name || "",
        }
        const response = await dispatch(addEditRelation(payload)).unwrap();
        if (response.IsSuccess) {
            toast.success(response.Message);
        }
        onClose();
    };
  
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black opacity-50 backdrop-blur-lg"></div>
      
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-3xl shadow-xl max-w-4xl w-full p-3 md:p-7">
          <div className="flex items-center justify-between p-4">
            <h3 className="text-18 lg:text-26 font-bold text-gray-900">Add Relation</h3>
            <button
              onClick={onClose}
              className="hover:text-text_1"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <Formik
            initialValues={formikInitialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, touched, isSubmitting, values }) => (
              <Form className="p-4">
                <div className="md:flex gap-4 mb-3 md:mb-5">
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2">
                      Relation Name (English)
                    </label>
                    <Field
                      name="english_name"
                      type="text"
                      className="mt-1 block w-full rounded-md px-3 py-2 bg-[#EEEEEE] focus:outline-none"
                    />
                  </div>
                  <div className="w-full md:w-1/2">
                    <label className="block text-16 font-semibold text-text_2">
                      Relation Name (Gujarati)
                    </label>
                    <Field
                      name="gujarati_name"
                      type="text"
                      className="mt-1 block w-full rounded-md px-3 py-2 bg-[#EEEEEE] focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-center p-4 space-x-3 xl:space-x-5">
                <button
                    type="button"
                    onClick={onClose}
                    className="btn_secondary">
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn py-2.5 md:py-3.5 px-8 md:px-12"
                  >
                    {isSubmitting ? "Submitting..." : "Save"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

AddEditRelation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object,
  getOccupationListFun: PropTypes.func,
  children: PropTypes.any,
};

export default AddEditRelation;
